import Icon from 'veui/components/Icon'
import { IconPause } from 'dls-icons-vue'

Icon.register('pause', IconPause)
